import { AdditionalAuthModal } from '../AdditionalAuth';
import { ReauthModal } from '../ReauthModal';

import { useGlobalAuthModal, AuthCancelledError } from './state';

/**
 * グローバル認証モーダルコンポーネント
 *
 * アプリケーション全体で使用される認証モーダルです。
 * API Interceptorから自動的に呼び出され、認証完了を待機できます。
 * authTypeに応じて、ReauthModal（パスワード再認証）またはAdditionalAuthModal（MFA追加認証）を表示します。
 */
export function GlobalAuthModal() {
  const { isOpen, authType, message, resolveAuth, rejectAuth } =
    useGlobalAuthModal();

  const handleAuthSuccess = async () => {
    // 認証成功時にPromiseを解決
    resolveAuth();
  };

  const handleCancel = () => {
    // キャンセル時にPromiseをreject
    rejectAuth(new AuthCancelledError());
  };

  if (authType === 'aal2') {
    return (
      <AdditionalAuthModal
        open={isOpen}
        description={message}
        onOpenChange={(open) => {
          if (!open) {
            handleCancel();
          }
        }}
        onAuthSuccess={handleAuthSuccess}
      />
    );
  }

  return (
    <ReauthModal
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          handleCancel();
        }
      }}
      onReauthSuccess={handleAuthSuccess}
    />
  );
}
